import { render, staticRenderFns } from "./JZJL.vue?vue&type=template&id=654bb349&scoped=true&"
import script from "./JZJL.vue?vue&type=script&lang=js&"
export * from "./JZJL.vue?vue&type=script&lang=js&"
import style0 from "./JZJL.vue?vue&type=style&index=0&id=654bb349&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bb349",
  null
  
)

export default component.exports